import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Link } from "react-router-dom";


function RelatedGames({ type, id }) {
  const {
    data: games,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["/api/content/games"],
    queryFn: async () => {
      const { data } = await axios.get(
        `https://be-staging.obigin.com/content/realated-games?type=${type}&id=${id}`
      );
      return data.data;
    },
  });

  if (isLoading) return <p>Loading games...</p>;
  if (isError) return <p>Failed to load games</p>;
  const imageHeight = type === "web" ? "350px" : "200px";

  return (
    <section className="upcoming-games-area upcoming-games-bg pt-40">
      <div className="container">
        <div className="row">
          {games?.map((game, idx) => (
            <div
              className="col-lg-4 col-md-6"
              key={idx}
              style={{ display: 'flex', marginBottom: '40px' }}
            >
              <Link
                to={`/details/${game._id}`}
                style={{ width: '100%' }}
              >
                <div
                  className="upcoming-game-item"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                  }}
                >
                  <div className="upcoming-game-head">
                    <div className="uc-game-head-title">
                      <span className="text-red">
                        <h1
                          className="text-red"
                        >
                          {game.name}
                        </h1>
                      </span>
                      <h4>
                        <a
                          href={game.link || "#"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {type}
                        </a>
                      </h4>
                    </div>
                  </div>
                  <p
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {game.shortDescription || "No description available."}
                  </p>
                  <div
                    className="upcoming-game-thumb"
                    style={{ marginTop: 'auto' }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: imageHeight,
                        objectFit: "contain",
                      }}
                      src={game.graphic || "assets/img/images/default_thumb.jpg"}
                      alt={game.name}
                    />
                    <div className="upcoming-game-cart">
                      <a href={game.link || "#"} className="btn transparent-btn">
                        <i className="fas fa-shopping-basket" />
                        {game.status === "live" ? "View Details" : "COMING SOON"}
                      </a>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RelatedGames;